import React from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const NavagrahasPage = () => {
  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `


  <h1>நவக்ரஹங்கள் பற்றிய தகவல் தொகுப்பு</h1>
<div class="accordion">

  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">குறிப்புகள்</div>
  </summary>
  <div class="div2"> 
  நவக்ரஹங்களின் பல்வேறு தன்மைகள் அனைத்தும் கீழ்க்கண்ட தலைப்புகளாகப் பிரித்து வழங்கப்பட்டுள்ளன.
  <ol class="myol">
    <li>க்ரஹங்களின் ராசி அமைவிடம்</li>
    <li>க்ரஹங்களின் ஆண் - பெண் பால்</li>
    <li>க்ரஹங்களின் மொழி</li>
    <li>க்ரஹங்களின் நிறம்</li>
    <li>க்ரஹங்களின் ஜாதி</li>
    <li>க்ரஹங்களின் குணம்</li>
    <li>க்ரஹங்களின் நோய்</li>
    <li>க்ரஹங்களின் திசை</li>
    <li>க்ரஹங்களின் ரத்தினம்</li>
    <li>க்ரஹங்களின் தான்யம்</li>
    <li>க்ரஹங்களின் புஷ்பம்</li>
    <li>க்ரஹங்களின் ஸமித்து</li>
    <li>க்ரஹங்களின் வாகனம்</li>
    <li>க்ரஹங்களின் சுவை</li>
    <li>க்ரஹங்களின் உலோகம்</li>
    <li>க்ரஹங்களின் சஞ்சார காலம்</li>
    <li>க்ரஹங்களின் தேவதை</li>
    <li>க்ரஹங்களின் வஸ்த்ரம்</li>
    <li>க்ரஹங்களின் க்ஷேத்ரம்</li>
    <li>க்ரஹங்களின் ஆசனம்</li>
    <li>க்ரஹங்களின் காயத்ரி மந்த்ரம்</li>
  </ol>


</div>
</details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">02-ராசி - அமைப்பு</div>
  </summary>
<div class="div2">
<table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
<tr style="border-bottom:1px solid #ccc">
  <td style="padding:8px; border:1px solid #e0e0e0">மீன ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0">மேஷ ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0">ரிஷப ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0">மிதுன ராசி</td>
</tr>
<tr style="border-bottom:1px solid #ccc">
  <td style="padding:8px; border:1px solid #e0e0e0">கும்ப ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0"></td>
  <td style="padding:8px; border:1px solid #e0e0e0">கடக ராசி</td>
</tr>
<tr style="border-bottom:1px solid #ccc">
  <td style="padding:8px; border:1px solid #e0e0e0">மகர ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0"></td>
  <td style="padding:8px; border:1px solid #e0e0e0">சிம்ம ராசி</td>
</tr>
<tr style="border-bottom:1px solid #ccc">
  <td style="padding:8px; border:1px solid #e0e0e0">தனுர் ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0">வ்ருச்சிக ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0">துலா ராசி</td>
  <td style="padding:8px; border:1px solid #e0e0e0">கன்னி ராசி</td>
</tr>
</table>
</div>



</details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">03-க்ரஹம்-ஆண்-பெண் தன்மை</div>
  </summary>
<div class="div2">
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">பால்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஆண்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">பெண்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஆண்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அலி</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஆண்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">பெண்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அலி</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அலி</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அலி</td>

    </tr>

  </table>
</div>



</details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">04-க்ரஹங்களின் தோற்றம்</div>
  </summary>
 <div class="div2">
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">தோற்றம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">சராசரி உயரம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">குள்ள வடிவம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">குள்ள வடிவம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">நெடிய வடிவம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">நெடிய வடிவம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">சராசரி உயரம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
      <td style="padding:8px; border:1px solid #e0e0e0">குள்ள வடிவம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">நெடிய வடிவம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
      <td style="padding:8px; border:1px solid #e0e0e0">நெடிய வடிவம்</td>

    </tr>

  </table>
</div>

</details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">05-க்ரஹங்களின் மொழி</div>
  </summary>
 <div class="div2">
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">மொழி</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஸம்ஸ்க்ருதம், தெலுங்கு</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">தமிழ்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">மந்த்ரம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஜ்யோதிஷம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஸம்ஸ்க்ருதம், தெலுங்கு</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">ஸம்ஸ்க்ருதம், தெலுங்கு</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அன்னிய மொழி</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அன்னிய மொழி</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
      <td style="padding:8px; border:1px solid #e0e0e0">அன்னிய மொழி</td>

    </tr>

  </table>
</div>
</details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">06-க்ரஹங்களின் நிறம்</div>
  </summary>
  

 <div class="div2">
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">நிறம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">சிவப்பு</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">வெள்ளை</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">சிவப்பு</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">பச்சை</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">மஞ்சள்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
      <td style="padding:8px; border:1px solid #e0e0e0">வெள்ளை</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
      <td style="padding:8px; border:1px solid #e0e0e0">கருப்பு</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
      <td style="padding:8px; border:1px solid #e0e0e0">கருநீலம்</td>

    </tr>
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
      <td style="padding:8px; border:1px solid #e0e0e0">பலவண்ணம்</td>

    </tr>

  </table>
</div>
</details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">07-க்ரஹங்களின் ஜாதி</div>
  </summary>
  <div class="div2">
    <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">ஜாதி</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">க்ஷத்ரியர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வைசியர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">க்ஷத்ரியர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வைசியர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">ப்ராஹ்மணர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">ப்ராஹ்மணர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
        <td style="padding:8px; border:1px solid #e0e0e0">இதரர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கலப்பு ஜாதி</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கலப்பு ஜாதி</td>

      </tr>

    </table>
  </div>
  </details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">08-க்ரஹங்களின் குணம்</div>
  </summary>
  <div class="div2">
    <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குணம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குரூரர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குளுமை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குரூரர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">தண்மை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">மிதமானவர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">சாந்தம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குரூரர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குரூரர்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
        <td style="padding:8px; border:1px solid #e0e0e0">குரூரர்</td>

      </tr>

    </table>
  </div>
  </details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">09-க்ரஹங்களின் நோய்</div>
  </summary>
  <div class="div2">
    <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">நோய்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பித்தம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">சிலேட்டுமம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பித்தம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வாதம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வாதம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">சிலேட்டுமம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வாதம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பித்தம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பித்தம்</td>

      </tr>

    </table>
  </div>

  </details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">10-க்ரஹங்களின் திசை</div>
  </summary>
  <div class="div2">
    <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">திசை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">மத்தி</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">தென்கிழக்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">தெற்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வடகிழக்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வடக்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கிழக்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
        <td style="padding:8px; border:1px solid #e0e0e0">மேற்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">தென்மேற்கு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வடமேற்கு</td>

      </tr>

    </table>
  </div>
  </details>
  
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">11-க்ரஹங்களின் ரத்னம்</div>
  </summary>
  <div class="div2">
    <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">ரத்னம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">மாணிக்கம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">முத்து</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பவளம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பச்சை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">புஷ்பராகம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வைரம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
        <td style="padding:8px; border:1px solid #e0e0e0">நீலம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கோமேதகம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
        <td style="padding:8px; border:1px solid #e0e0e0">வைடூர்யம்</td>

      </tr>

    </table>
  </div>
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
  
  </details>
  <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
   <div class="head3">12-க்ரஹங்களின் தான்யம்</div>
  </summary>
  <div class="div2">
    <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">தான்யம்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கோதுமை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">நெல்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">துவரை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">பயறு</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கடலை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
        <td style="padding:8px; border:1px solid #e0e0e0">மொச்சை</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
        <td style="padding:8px; border:1px solid #e0e0e0">எள்</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
        <td style="padding:8px; border:1px solid #e0e0e0">உளுந்து</td>

      </tr>
      <tr style="border-bottom:1px solid #ccc">
        <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
        <td style="padding:8px; border:1px solid #e0e0e0">கொள்</td>

      </tr>

    </table>
  </div>
  </details>
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
      <div class="head3">13-க்ரஹங்களின் புஷ்பம் </div>
    </summary>
    <div class="div2">
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">புஷ்பம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">செந்தாமரை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">வெள் அலரி</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">செண்பகம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">வெண்காந்தள்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">முல்லை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">வெண்தாமரை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
          <td style="padding:8px; border:1px solid #e0e0e0">கருங்குவளை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">மந்தாரை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வலரி</td>

        </tr>

      </table>
    </div>

  
    </details>
    
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
      <div class="head3">14-க்ரஹங்களின் ஸமித்து </div>
    </summary>
    <div class="div2">
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">ஸமித்து</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">எருக்கு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">முருக்கு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">கருங்காலி</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">நாயுறுவி</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">அரசு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">அத்தி</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
          <td style="padding:8px; border:1px solid #e0e0e0">வன்னி</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">அருகம்புல்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
          <td style="padding:8px; border:1px solid #e0e0e0">தர்பை</td>

        </tr>

      </table>
    </div>

  
    </details>
    
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
      <div class="head3">15-க்ரஹங்களின் வாகனம் </div>
    </summary>
    <div class="div2">
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">வாகனம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">மயில், தேர்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">முத்து விமானம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">அன்னம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">குதிரை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">யானை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">கருடன்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
          <td style="padding:8px; border:1px solid #e0e0e0">காகம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">ஆடு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
          <td style="padding:8px; border:1px solid #e0e0e0">சிங்கம்</td>

        </tr>

      </table>
    </div>

  
    </details>
    
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
      <div class="head3">16-க்ரஹங்களின் சுவை </div>
    </summary>
    <div class="div2">
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">சுவை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">காரன்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">இனிப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">துவர்ப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">உப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">இனிப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">இனிப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
          <td style="padding:8px; border:1px solid #e0e0e0">கைப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">புளிப்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
          <td style="padding:8px; border:1px solid #e0e0e0">புளிப்பு</td>

        </tr>

      </table>
    </div>

  
    </details>
    
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
      <div class="head3">17-க்ரஹங்களின் உலோகம் </div>
    </summary>
    <div class="div2">
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">உலோகம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">செம்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">ஈயம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">செம்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">பித்தளை</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">தங்கம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">வெள்ளி</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
          <td style="padding:8px; border:1px solid #e0e0e0">இரும்பு</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">கருங்கல்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
          <td style="padding:8px; border:1px solid #e0e0e0">துரு</td>

        </tr>

      </table>
    </div>

  
  </details>
    
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
      <div class="head3">18-க்ரஹங்களின் சஞ்சார காலம் </div> 
    </summary>
    <div class="div2">
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">காலம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1 மாதம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">2¼ நாள்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1½ மாதம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1 மாதம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1 வருடம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1 மாதம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
          <td style="padding:8px; border:1px solid #e0e0e0">2½ வருடம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1½ வருடம்</td>

        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
          <td style="padding:8px; border:1px solid #e0e0e0">1½ வருடம்</td>

        </tr>

      </table>
    </div>

  
    </details>
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
        <div class="head3">19-க்ரஹங்களின் தேவதை </div>
      </summary>
      <div class="div2">
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">தேவதை</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">சிவன்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பார்வதி</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">சுப்ரமண்யர்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">விஷ்ணு</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ப்ரஹ்மா</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">லக்ஷ்மி</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
            <td style="padding:8px; border:1px solid #e0e0e0">எமன்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பத்ரகாளி</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
            <td style="padding:8px; border:1px solid #e0e0e0">இந்த்ரன்</td>

          </tr>

        </table>
      </div>
     
      </details>
      
      <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
        <div class="head3">20-க்ரஹங்களின் வஸ்த்ரம் </div>    
      </summary>
      <div class="div2">
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வஸ்த்ரம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">சிவப்பு</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வெள்ளை</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">சிவப்பு</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பச்சை</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">மஞ்சள்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வெள்ளை</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
            <td style="padding:8px; border:1px solid #e0e0e0">கருப்பு</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">கருநீலம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பலவண்ணம்</td>

          </tr>

        </table>
      </div>

    
      </details>
      
      <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
        <div class="head3">21-க்ரஹங்களின் க்ஷேத்ரம் </div>
      </summary>
      <div class="div2">
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">க்ஷேத்ரம் </td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ஆடுதுறை</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">திருப்பதி</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வைதீஸ்வரன்கோயில்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">மதுரை சொக்கநாதர்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">திருச்செந்தூர்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ஸ்ரீரங்கம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
            <td style="padding:8px; border:1px solid #e0e0e0">திருநள்ளார்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">காளஹஸ்தி</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
            <td style="padding:8px; border:1px solid #e0e0e0">காளஹஸ்தி</td>

          </tr>

        </table>
      </div>

    
      </details>
      
      <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
        <div class="head3">22-க்ரஹங்களின் வடிவம் </div>
      </summary>
      <div class="div2">
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">க்ரஹம்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வடிவம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சூரியன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வட்டம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சந்திரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">சதுரம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">செவ்வாய்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">முக்கோணம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">புதன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">அம்பு வடிவம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">குரு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">நீள் சதுரம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சுக்ரன்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ஐங்கோணம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சனி</td>
            <td style="padding:8px; border:1px solid #e0e0e0">வில் வடிவம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">ராகு</td>
            <td style="padding:8px; border:1px solid #e0e0e0">கொடி  வடிவம்</td>

          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கேது</td>
            <td style="padding:8px; border:1px solid #e0e0e0">மந்தை</td>

          </tr>

        </table>
      </div>

    
      </details>
      
      <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
        <div class="head3">23-க்ரஹங்களின் காயத்ரி </div> 
      </summary>
      <div class="mydiv">
        <ol>
          <li>ஓம் அஸ்வத்வஜாய வித்மஹே பாஸஹஸ்தாய தீமஹி
            <br> தந்நஸ் ஸூர்ய: ப்ரசோதயாத்</li>
          <hr>

          <li>ஓம் பத்மத்வஜாய வித்மஹே ஹேமரூபாய தீமஹி
            <br> தந்நஸ் ஸோம: ப்ரசோதயாத்.</li>
          <hr>

          <li>ஓம் வீரத்வஜாய வித்மஹே விக்ந ஹஸ்தாய தீமஹி
            <br> தந்நோ பௌம: ப்ரசோதயாத் .</li>
          <hr>

          <li>ஓம் கஜத்வஜாய வித்மஹே ஸூகஹஸ்தாய தீமஹி
            <br> தந்நோ புத: ப்ரசோதயாத் .</li>
          <hr>

          <li>ஓம் வ்ருஷபத்வஜாய வித்மஹே க்ருணீ ஹஸ்தாய தீமஹி
            <br> தந்நோ குரு: ப்ரசோதயாத் .</li>
          <hr>

          <li>ஓம் அஸ்வத்வஜாய வித்மஹே தநுர்ஹஸ்தாய தீமஹி
            <br> தந்ந: சுக்ர: ப்ரசோதயாத் .</li>
          <hr>

          <li>ஓம் காகத்வஜாய வித்மஹே கட்க ஹஸ்தாய தீமஹி
            <br> தந்நோ மந்த: ப்ரசோதயாத் .</li>
          <hr>

          <li>ஓம் நாகத்வஜாய வித்மஹே பத்ம ஹஸ்தாய தீமஹி
            <br> தந்நோ ராஹு: ப்ரசோதயாத் .</li>
          <hr>

          <li>ஓம் அஸ்வத்வஜாய வித்மஹே சூலஹஸ்தாய தீமஹி
            <br> தந்நோ கேது: ப்ரசோதயாத் .</li>
        </ol>

      </div>
      
          
      </details> 
      
  </div>
` }} />
    </div>
  );
};

export default NavagrahasPage;
